/**
 * DEPLOYMENT CONFIG — the ONLY place in src/ with customer-specific identity.
 *
 * GoldBuy is a white-label product (DROYVA). Everything visual comes from
 * Firestore `app_config/settings` (branding.appName/shortName/logo/colors);
 * the values below are the FUNCTIONAL identity of THIS deployment and are
 * swapped once when standing up a new customer.
 *
 * Reference deployment: ArtGold Jewelry (Everett, MA).
 */

// Accounts that always resolve as master admins (bootstrap + break-glass).
export const MASTER_ADMINS = ['admin@artgoldjewelry.com', 'contact@artgoldjewelry.com']

// Vendor/brand stamped on Shopify products and marketplace metadata.
export const BRAND_VENDOR = 'ArtGold'

// Shown to signed-in users who lack a role (who to ask for access).
export const ACCESS_CONTACT_EMAIL = 'contact@artgoldjewelry.com'
